import { actions } from "@grandvisionhq/state";
const setPreferredShippingMethod = actions.action(
  "shipping-methods/set-preferred-shipping-method",
  actions.payload()
);
export {
  setPreferredShippingMethod
};
//# sourceMappingURL=actions.js.map
